import React from 'react';

const Footer = () => {
    return (
        <footer className='footer'>
            &copy; 2022 by Nhu Nguyen
        </footer>
    );
}

export default Footer;